import type { ApiClient } from "@jace/api";
import { createContext } from "react";

export const ApiClientContext = createContext<{ client: ApiClient } | null>(
	null,
);
